import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27b75fba"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "visually-hidden"
}
const _hoisted_3 = {
  key: 1,
  class: "icon icon-cart btn-icon__icon"
}
const _hoisted_4 = {
  key: 2,
  class: "icon icon-cart me-2"
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = {
  key: 0,
  class: "fullscreen-modal",
  style: {"display":"block"},
  "aria-modal": "true",
  role: "dialog"
}
const _hoisted_7 = {
  class: "fullscreen-modal__dialog",
  ref: "modalRef"
}
const _hoisted_8 = { class: "fullscreen-modal__content" }
const _hoisted_9 = { class: "fullscreen-modal__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: _normalizeClass(_ctx.buttonConfig.class),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show(_ctx.buttonConfig.triggerTracking))),
      "aria-label": _ctx.buttonConfig.text
    }, [
      (_ctx.buttonConfig.onlyIcon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.buttonConfig.text), 1))
        : _createCommentVNode("", true),
      (_ctx.buttonConfig.onlyIcon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
        : _createCommentVNode("", true),
      (!_ctx.buttonConfig.onlyIcon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4))
        : _createCommentVNode("", true),
      (!_ctx.buttonConfig.onlyIcon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.buttonConfig.text), 1))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        name: "fade",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_ctx.showModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_ModalHeader, {
                      onCloseModal: _ctx.close,
                      type: _ctx.type
                    }, null, 8, ["onCloseModal", "type"]),
                    _createElementVNode("div", _hoisted_9, [
                      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                    ]),
                    (_ctx.step !== _ctx.stepViews.length)
                      ? (_openBlock(), _createBlock(_component_ModalFooter, {
                          key: 0,
                          onAddToCart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emit('addToCart'))),
                          onCloseModal: _ctx.close,
                          stepViews: _ctx.stepViews,
                          step: _ctx.step,
                          type: _ctx.type
                        }, null, 8, ["onCloseModal", "stepViews", "step", "type"]))
                      : _createCommentVNode("", true)
                  ])
                ], 512)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]))
  ], 64))
}